import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const ActionContainer = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'row',

  '.cardHeaderActions': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '.MuiCardHeader-action':{
      margin:0,
    },

    'button, button:active, button:focus': {
      background: 'transparent',
    },

    'button:hover': {
      background: '#DDD'
    },

    'button.hiddenButton': {
      color: 'transparent',
      background: 'transparent',
    },
  
    'button.hiddenButton:hover': {
      color: 'transparent',
      background: 'transparent',
      cursor: 'unset',
    },
  
    'button.hiddenButton:focus': {
      color: 'transparent',
      background: 'transparent',
      cursor: 'unset',
    },
  
    'button.hiddenButton:active': {
      color: 'transparent',
      background: 'transparent',
      cursor: 'unset',
    },
  }
}))

export const Cont = styled.div((props) => ({
  flex:props.flexZero?0:1,
  marginTop: '15px',
  
  '.MuiCardHeader-action':{
    margin:0,
  },

  '.MuiTypography-h5':{
    fontSize:'inherit',
    lineHeight:'inherit',
    fontWeight:'bold'
  },

  '.MuiCardHeader-root': {
    padding: '0.3125rem 1rem',
  },

  '.headerText':{
    fontWeight:'bold',
    fontSize:'1.2rem',
    color:`${v.ezMainColor}`
  },

  '.stepTitle':{
    color:`${v.ezMainColor}`,
    fontSize:'1.2rem',
    fontWeight:'bold'
  }
}))
